import React from 'react'
import { cn } from '@/lib/utils'
import LcIcon from '@/components/livecontact/icons'
import Spinner from '@/components/livecontact/Spinner'

type NotifyProps = {
  className?: string
  iconCheck?: boolean
  iconDelete?: boolean
  iconLoading?: boolean
  iconError?: boolean
  children: React.ReactNode
}

const TILE = 'flex size-6 shrink-0 items-center justify-center rounded-full'

/** Toast body: white card with the pop shadow, a 24px status tile and 14px copy. */
const Notify = ({ className, iconCheck, iconDelete, iconError, iconLoading, children }: NotifyProps) => (
  <div
    className={cn(
      'flex items-center gap-3 rounded-[12px] bg-surface py-3 pl-3 pr-4 text-[14px] font-medium leading-[1.4] tracking-[-0.2px] text-ink shadow-pop',
      className
    )}
    role="status"
  >
    {iconCheck && (
      <span className={cn(TILE, 'bg-success text-white')}>
        <LcIcon name="check" size={12} strokeWidth={2.5} />
      </span>
    )}
    {iconDelete && (
      <span className={cn(TILE, 'bg-[#D33] text-white')}>
        <LcIcon name="trash" size={12} />
      </span>
    )}
    {iconLoading && (
      <span className={cn(TILE, 'bg-canvas text-brand')}>
        <Spinner className="size-3.5" />
      </span>
    )}
    {iconError && (
      <span className={cn(TILE, 'bg-[#D33] text-white')}>
        <LcIcon name="close" size={12} strokeWidth={2} />
      </span>
    )}
    <span className="min-w-0">{children}</span>
  </div>
)

export default Notify
